// extracted by mini-css-extract-plugin
export default {"btn_container":"hero_btn_container__SObkF","language":"hero_language__1vdrg","btn_hero":"hero_btn_hero__TB19+"};